export enum ButtonColor {
  PRIMARY = "primary",
  DISABLED = "disabled",
  ORIGIN_GRAY = "gray",
  CUSTOM_GRAY = "custom-gray",
  WHITE = "white",
  GREEN = "green",
  RED = "red",
  PRIMARY_OUTLINE = "primaryOutline",
  GRAY_OUTLINE = "grayOutline",
  TRANSPARENT_OUTLINE = "transparentOutline",
  WARNING = "warning",
}

export const ButtonTextColorMap = {
  [ButtonColor.PRIMARY]: "text-primary-black",
  [ButtonColor.DISABLED]: "text-semantic-text-disabled",
  [ButtonColor.ORIGIN_GRAY]: "text-grayscale-contrast-80",
  [ButtonColor.CUSTOM_GRAY]: "text-grayscale-contrast-80",
  [ButtonColor.WHITE]: "text-semantic-text-body",
  [ButtonColor.GREEN]: "text-semantic-success-success-text ",
  [ButtonColor.RED]: "text-semantic-system-error-text",
  [ButtonColor.PRIMARY_OUTLINE]: "text-semantic-text-body",
  [ButtonColor.GRAY_OUTLINE]: "text-semantic-text-body",
  [ButtonColor.TRANSPARENT_OUTLINE]: "text-semantic-text-body",
  [ButtonColor.WARNING]: "text-semantic-warning-warning-text",
};
